// Row-shaping helpers for the Fraud Alerts hub. "New" is frontend-derived:
// an alert is New for NEW_WINDOW_DAYS after publish, then becomes Current.

export const NEW_WINDOW_DAYS = 30;

// ic3.gov PSA URLs look like https://www.ic3.gov/PSA/2025/PSA250813 —
// fallback for legacy rows without an explicit psa_number.
const PSA_URL_RE = /PSA\/(\d{4})\/(PSA\d+[a-z]?)/i;

export function derivePsaNumber(url) {
  if (!url) return null;
  const m = url.match(PSA_URL_RE);
  return m ? `I - ${m[2].replace(/^PSA/i, '')}` : null;
}

export function isNew(publishedAt) {
  const t = new Date(publishedAt).getTime();
  if (Number.isNaN(t)) return false;
  return Date.now() - t < NEW_WINDOW_DAYS * 24 * 60 * 60 * 1000;
}

// Mockup date format: "03. 12. 2026". UTC getters — publish dates are
// date-oriented (stored at UTC midnight) and must not shift across timezones.
export function fmtDotDate(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${mm}. ${dd}. ${d.getUTCFullYear()}`;
}

// Normalize an ic3_alerts row into the table/detail shape.
export function normalizeAlert(a) {
  return {
    id: a.id,
    title: a.title,
    psaNumber: a.psa_number || derivePsaNumber(a.source_url),
    publishedAt: a.published_at,
    dateLabel: fmtDotDate(a.published_at),
    isNew: isNew(a.published_at),
    url: a.source_url || null,
    // Per-user read marker from alert_views; absent for sources that don't
    // track it, which renders as unviewed.
    viewed: Boolean(a.viewed),
  };
}
